import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmApplySnapshotDialogData {
  snapshotName: string;
}

export interface ConfirmApplySnapshotDialogResult {
  action: 'apply_without_saving' | 'save_and_apply' | 'cancel';
}

@Component({
  selector: 'app-confirm-apply-snapshot-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './confirm-apply-snapshot-dialog.component.html',
  styleUrls: ['./confirm-apply-snapshot-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmApplySnapshotDialogComponent {
  private dialogRef = inject<MatDialogRef<ConfirmApplySnapshotDialogComponent>>(MatDialogRef);
  data = inject<ConfirmApplySnapshotDialogData>(MAT_DIALOG_DATA);


  onApplyWithoutSaving(): void {
    this.dialogRef.close({
      action: 'apply_without_saving',
    } as ConfirmApplySnapshotDialogResult);
  }

  onSaveAndApply(): void {
    this.dialogRef.close({
      action: 'save_and_apply',
    } as ConfirmApplySnapshotDialogResult);
  }

  onCancel(): void {
    this.dialogRef.close({
      action: 'cancel',
    } as ConfirmApplySnapshotDialogResult);
  }
}
